// extracted by mini-css-extract-plugin
export default {"wrapper":"WidgetButton_wrapper__h24eh","badge":"WidgetButton_badge__c36Qh"};